import Cookies from 'js-cookie'

function needRelogin () {
  return Cookies.get('backendVersion001') === undefined
}

function hasLogin () {
  if (needRelogin()) {
    clearLoginCredential()
  }

  if (Cookies.get('g.token') === undefined) {
    return false
  }
  let user = getUser()
  if (user.role === undefined) {
    return false
  }

  return true
}

function clearLoginCredential () {
  localStorage.clear()
  Cookies.remove('g.user')
  Cookies.remove('g.token')
}

function getUser () {
  let content = Cookies.get('g.user')
  return content ? JSON.parse(content) : null
}

export {
  hasLogin,
  getUser,
  clearLoginCredential
}
